import ApiResponseBase from '../../../../Base/Domain/ApiResponseBase';
import MembershipRedemptionDetailsModel from '../MembershipRedemptionDetailsModel';

class GetMembershipRedemptionResponseModel extends ApiResponseBase {

  constructor(params) {

    super(params);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

    this.MembershipRedemption = new MembershipRedemptionDetailsModel(params.membershipRedemption);

  }

}

export default GetMembershipRedemptionResponseModel;